import Vue from 'vue'
import VueI18n from 'vue-i18n'

// This file contains all the strings shown to a user on the website, in English and French

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: 
  { 
    en: {
          //Home page strings
          homeWelcome: 'Welcome to the CHIME/FRB Public Database',
          homeLearnMore: 'Learn More About CHIME',
          homeRealTime: 'Real-Time Database for Fast Radio Bursts',
          homeEventsDetected: 'Events detected by CHIME/FRB are reported to this database in real time. View the latest events or search for specific ones in the events page.',
          homeAnalysis: 'A bit about the CHIME/FRB Data Analysis Pipelines',
          homePartOf: 'Part of CHIME',
          homePartOfDesc: 'CHIME/FRB is an instrument added to the Canadian Hydrogen Intensity Mapping Experiment......',
          homeMadeTo: 'Excellent at detecting FRBs',
          homeMadeToDesc: 'Fast Radio Bursts (FRBs) are brief (few millisecond) bursts of radio waves coming from far beyond our Milky Way galaxy.......',

          //App strings
          navHome: 'HOME',
          navRepeaters: 'Repeating FRBs',
          navCatalog: 'Catalog1',
          navBaseCat1: 'Baseband Catalog 1',
          navRepeaterCatalog: 'CHIME/FRB Collaboration (2023) Catalog',
          navLatest: 'Latest',
          navFRBs: 'FRBs',
          navGalactic: 'Galactic Sources',
          navAnalysis: 'Information',
          navVoeventInfo: 'VOEvents',
          navUser: 'User',
          navSignOut: 'Sign Out',
          footPoweredBy: 'Powered By',
          navAstronomyTools: 'Transit Calculator',

          //latest Strings
          latestTitle: 'FRBs',
          latestAddFilter: 'Add filter',
          latestFilterDesc: 'Filter Functionality:\nFilters can be used to constrain the events to be shown to the right. When a filter is ' +
          'generated using the Add filter button, you may select which event property to filter by. You may indicate a range, or only a maximum ' +
          'or minimum. When you are satisfied with the filters, click the submit button to generate the event table.',
          latestDelete: 'Delete',
          latestSelect: 'Please select a filter',
          latestSubmit: 'Submit',
          latestOneFilter: 'Please only create one filter of each type',
          latestNoResult: 'Sorry, no results were found',
          latestTime: 'UTC Time'
        }, 

    fr: {
          //Home page strings
          homeWelcome: 'Bienvenue à la base de données publique de CHIME/FRB',
          homeLearnMore: 'En savoir plus',
          homeRealTime: 'Base de données de Sursauts Radio Rapides en temp réel',
          homeEventsDetected: 'Les événements détectés par CHIME/FRB sont inscrits dans cette base de données en temps réel. Visionnez les derniers événements, ou cherchez pour des événement particuliers dans l\'onglet Derniers.',
          homeAnalysis: 'À propos de CHIME/FRB',
          homePartOf: 'Fait partie de CHIME',
          homePartOfDesc: 'CHIME/FRB est un instrument ajouté a l\'expérience canadienne de cartographie de l\'intensité de l\'hydrogène (Canadian Hydrogen Intensity Mapping Experiment, CHIME)......',
          homeMadeTo: 'Bâti pour détecter des FRBs',
          homeMadeToDesc: 'Les sursauts radio rapides sont de brefs sursauts d’ondes radio (de quelques millisecondes) en provenance de sources situées bien au-delà de notre galaxie.',

          //App strings
          navHome: 'Accueil',
          navRepeaters: 'Répétiteurs', //
          navLatest: 'Derniers',
          navAnalysis: 'Découvrez-nous',
          navUser: 'Utilisateur',
          navSignOut: 'Se déconnecter',
          footPoweredBy: 'Propulsé par',

          //latest trings
          latestTitle: 'Derniers FRBs détectés',
          latestAddFilter: 'Ajouter un filtre',
          latestFilterDesc: 'Fonctionnement des filtres:\nLes filtres peuvent être utilisés afin de chercher des événements. Les filtres ' +
          'sont créés a l\'aide du bouton Ajouter un filter, et permettent de filtrer selon les differentes propriétés des événements. Il est possible d\'indiquer un minimum et un maximum, ou seulement l\'un des deux. ' +
          'Appuyez sur le boutton soumettre afin de regénérer la page à droite.',
          latestDelete: 'Suppr.',
          latestSelect: 'Sélectionnez un filtre',
          latestSubmit: 'Soumettre',
          latestOneFilter: 'SVP, ne créez qu\'un filtre de chaque type',
          latestNoResult: 'Malheureusement, aucun resultat trouvé',
          latestTime: 'Temps UTC'

        }
  }
})